import { AddTagButton } from "modules/customers/components/Tags/AddTagButton"
import { TagBadge } from "modules/customers/components/Tags/TagBadge"
import { TagsPicker } from "modules/customers/components/Tags/TagsPicker"
import { useTagsQuery } from "modules/customers/hooks/useTagsQuery"
import { useTranslation } from "react-i18next"
import { CustomerTagsResponseDataSchema } from "schema"
import { z } from "zod"

type Props = {
  tags: z.infer<typeof CustomerTagsResponseDataSchema>
  value: string[]
  onChange: (value: string[]) => void
}

export function CustomerTags({ tags, value, onChange }: Props) {
  const { t } = useTranslation()
  const { data: companyTags = [] } = useTagsQuery()

  const shopifyTagNames = tags.filter((tag) => tag.source === "Shopify").map((tag) => tag.name)

  function add(name: string) {
    if (!value.includes(name)) onChange([...value, name])
  }

  function remove(name: string) {
    onChange(value.filter((selectedName) => selectedName !== name))
  }

  function toggle(name: string) {
    if (value.includes(name)) {
      remove(name)
    } else {
      add(name)
    }
  }

  return (
    <div className="grid grid-cols-[9rem_minmax(0,1fr)] items-start gap-3 pt-1">
      <span className="text-sm text-muted-foreground leading-8">{t("customers.tags.title")}</span>
      <div className="flex flex-wrap items-center gap-1.5">
        <TagsPicker
          options={companyTags
            .filter((tag) => !shopifyTagNames.includes(tag.name))
            .map((tag) => ({ value: tag.name, label: tag.name }))}
          selectedValues={value}
          onToggle={toggle}
          onCreate={add}
        >
          <AddTagButton />
        </TagsPicker>
        {value.map((name) => (
          <TagBadge key={name} name={name} onRemove={() => remove(name)} />
        ))}
      </div>
    </div>
  )
}
